module.exports = __webpack_public_path__ + "static/media/screen1.cec090a7.png";